import { DEFAULT_LANGUAGE } from 'app/config/languages.config';
import { AG_GRID_LOCALE_IT } from './ag-grid.it';
import { AG_GRID_LOCALE_EN } from './ag-grid.en';

export const AG_GRID_LOCALES: Record<string, any> = {
	it: AG_GRID_LOCALE_IT,
	en: AG_GRID_LOCALE_EN,
};

/**
 * Returns the AG-Grid locale dictionary for a given language code.
 * Falls back to DEFAULT_LANGUAGE (or English/Italian) if not found.
 */
export function getAgGridLocale(langCode?: string): Record<string, any> {
	const code = langCode || DEFAULT_LANGUAGE.code;
	return AG_GRID_LOCALES[code] || AG_GRID_LOCALES[DEFAULT_LANGUAGE.code] || AG_GRID_LOCALE_IT;
}

export { AG_GRID_LOCALE_IT, AG_GRID_LOCALE_EN };
